document.addEventListener('DOMContentLoaded', function () {

const collectionSlider = document.querySelector('.swiper.main-products-grid');
    const collSlider = new Swiper(collectionSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: false,
      
      // Navigation arrows
      navigation: {
        nextEl: `.swiper.main-products-grid .swiper-button-next`,
        prevEl: `.swiper.main-products-grid .swiper-button-prev`,
      },

      // Responsive breakpoints
      breakpoints: {
        769: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
      },
    });
});